import cloneDeep from 'lodash/cloneDeep';
import { AcdEntityNameEnum, DataEntityEnum, Stage, StageStatusEnum, WidgetData, WidgetTypeEnum } from '../../models/Index';

function migrateStageData(stage: Stage): Stage {
    const tempStage = cloneDeep(stage) as Stage;
    // Migrate from gridConfig to publishedGridconfig if gridConfig is "there". Delete gridConfig afterwards (DI-1433)
    if (tempStage.gridConfig) {
        tempStage.publishedGridConfig = tempStage.gridConfig;
        tempStage.workInProgressGridConfig = tempStage.gridConfig;
        tempStage.status = StageStatusEnum.PUBLISHED;
        delete tempStage.gridConfig;
    }
    // Migrate from widgetData to publishedWidegtData if widgetData is "there". Delete widgetData afterwards (DI-1433)
    if (tempStage.widgetData) {
        tempStage.publishedWidgetData = tempStage.widgetData;
        tempStage.workInProgressWidgetData = tempStage.widgetData;
        tempStage.status = StageStatusEnum.PUBLISHED;
        delete tempStage.widgetData;
    }

    return tempStage as Stage;
}

function migrateWidgetData(widgetData: WidgetData[]): WidgetData[] {
    const tempWidgetData = cloneDeep(widgetData) as WidgetData[];
    if (widgetData?.length > 0) {
        tempWidgetData.forEach((widgetData) => {
            /*if (widgetData.dataEntity === 'voiceentrance') widgetData.dataEntity = DataEntityEnum.ACD_ENTRANCE_VOICE;
            if (widgetData.dataEntity === 'nonvoicegroup') widgetData.dataEntity = DataEntityEnum.ACD_GROUP_NONVOICE;
            if (widgetData.dataEntity === 'group') widgetData.dataEntity = DataEntityEnum.ACD_GROUP_SUMMARY;
            if (widgetData.dataEntity === 'voicegroup') widgetData.dataEntity = DataEntityEnum.ACD_GROUP_VOICE;
            if (widgetData.dataEntity === 'user') widgetData.dataEntity = DataEntityEnum.ACD_USER;
            if (widgetData.dataEntity === 'usersummary') widgetData.dataEntity = DataEntityEnum.ACD_USER_SUMMARY;
            if (widgetData.dataEntity === 'obmOverview') widgetData.dataEntity = DataEntityEnum.OBM_OVERVIEW;
            if (widgetData.dataEntity === 'obmSummaryOverview') widgetData.dataEntity = DataEntityEnum.OBM_SUMMARY_OVERVIEW;
            if (widgetData.dataEntity === 'obmSummaryUserRanking') widgetData.dataEntity = DataEntityEnum.OBM_SUMMARY_USER_RANKING;
            if (widgetData.dataEntity === 'obmUserRanking') widgetData.dataEntity = DataEntityEnum.OBM_USER_RANKING;*/

            if (widgetData.dataEntity === 'entrance') widgetData.dataEntity = AcdEntityNameEnum.ACD_ENTRANCE_VOICE;
            if (widgetData.dataEntity === 'group') widgetData.dataEntity = AcdEntityNameEnum.ACD_GROUP_NONVOICE;
            if (widgetData.dataEntity === 'group_summary') widgetData.dataEntity = AcdEntityNameEnum.ACD_GROUP_SUMMARY;
            if (widgetData.dataEntity === 'group_extra') widgetData.dataEntity = AcdEntityNameEnum.ACD_GROUP_VOICE;
            if (widgetData.dataEntity === 'user') widgetData.dataEntity = AcdEntityNameEnum.ACD_USER;
            if (widgetData.dataEntity === 'user_summary') widgetData.dataEntity = AcdEntityNameEnum.ACD_USER_SUMMARY;
            if (widgetData.dataEntity === 'campaign') widgetData.dataEntity = AcdEntityNameEnum.OBM_OVERVIEW;
            if (widgetData.dataEntity === 'campaign_summary') widgetData.dataEntity = AcdEntityNameEnum.OBM_SUMMARY_OVERVIEW;
            if (widgetData.dataEntity === 'campaign_summary_extra') widgetData.dataEntity = AcdEntityNameEnum.OBM_SUMMARY_USER_RANKING;
            if (widgetData.dataEntity === 'campaign_extra') widgetData.dataEntity = AcdEntityNameEnum.OBM_USER_RANKING;

            if (widgetData.type === 'WALLBOARD_BOTTOM') widgetData.type = WidgetTypeEnum.ACD_WALLBOARD_BOTTOM;
            if (widgetData.type === 'WALLBOARD_RIGHT') widgetData.type = WidgetTypeEnum.ACD_WALLBOARD_RIGHT;
            if (widgetData.type === 'CLOCK') widgetData.type = WidgetTypeEnum.CLOCK;
            if (widgetData.type === 'FREE_TEXT') widgetData.type = WidgetTypeEnum.FREE_TEXT;
            if (widgetData.type === 'NOT_SELECTED') widgetData.type = WidgetTypeEnum.NOT_SELECTED;
            if (widgetData.type === 'OBM_CAMPAIGN_OVERVIEW') widgetData.type = WidgetTypeEnum.OBM_CAMPAIGN_OVERVIEW;
            if (widgetData.type === 'USER_RANKING') widgetData.type = WidgetTypeEnum.OBM_USER_RANKING;
            if (widgetData.type === 'RSS_FEED') widgetData.type = WidgetTypeEnum.RSS_FEED;
            if (widgetData.type === 'SINGLE_VALUE') widgetData.type = WidgetTypeEnum.SINGLE_VALUE;
            if (widgetData.type === 'VIDEO') widgetData.type = WidgetTypeEnum.VIDEO;
            if (widgetData.type === 'WEATHER') widgetData.type = WidgetTypeEnum.WEATHER;

            // Check if titleSize is set wrt UI in WidgetEditor. If not -> 1.5rem
            if (!widgetData.titleFontSize) {
                widgetData.titleFontSize = '1.5rem';
            }

            // Check if interval is set wrt UI in WidgetEditor in seconds (= no RSS_FEED). If not -> 20000
            if (
                [
                    WidgetTypeEnum.ACD_WALLBOARD_BOTTOM,
                    WidgetTypeEnum.ACD_WALLBOARD_RIGHT,
                    // WidgetTypeEnum.OBM_CAMPAIGN_OVERVIEW,
                    // WidgetTypeEnum.OBM_USER_RANKING,
                    WidgetTypeEnum.SINGLE_VALUE,
                ].includes(widgetData.type) &&
                ![30000, 20000, 10000].includes(widgetData.interval)
            ) {
                widgetData.interval = 20000;
            }

            // Check if interval is set wrt UI in WidgetEditor in minutes (= RSS_FEED only). If not -> 60000 (equals one minute)
            if ([WidgetTypeEnum.RSS_FEED].includes(widgetData.type) && widgetData.interval % 60000 !== 0) {
                widgetData.interval = 60000;
            }

            // Check if interval is set wrt UI in WidgetEditor in minutes (= OBM_CAMPAIGN_OVERVIEW || OBM_USER_RANKING). If not -> 60000 (equals one minute)
            // TODO: remove following if-statement and comment in lines 41 & 42 when OBM-Rest Bug from DI-1271 is fixed so that a response is to be expected in an acceptable time
            if (
                [WidgetTypeEnum.OBM_CAMPAIGN_OVERVIEW, WidgetTypeEnum.OBM_USER_RANKING].includes(widgetData.type) &&
                widgetData.interval % 60000 !== 0
            ) {
                widgetData.interval = 60000;
            }

            // Check if presentationStyle is set. If not set intially to number
            if ([WidgetTypeEnum.SINGLE_VALUE].includes(widgetData.type) && !widgetData.presentationStyle) {
                widgetData.presentationStyle = 'number';
            }
        });
    }
    return tempWidgetData as WidgetData[];
}

const MigrationService = {
    migrateStageData,
    migrateWidgetData,
};

export default MigrationService;
